// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3b61c9b6","453":"dad1e78f","732":"a27adf90","977":"b5f771aa"}[chunkId] + ".chunk.js";
};